import { MongoTeamId } from "@redotech/redo-model/mongo-ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { BackfillEmailChannelSchema } from "./get-support-backfill-messages";

export const TriggerSupportV2EmailBackfillResult = z.object({
  teamId: MongoTeamId.schema,
  success: z.boolean(),
  message: z.string(),
  workflowId: z.string().optional(),
  integrationId: z.string().optional(),
  email: z.string().optional(),
});
export type TriggerSupportV2EmailBackfillResult = z.infer<
  typeof TriggerSupportV2EmailBackfillResult
>;

// endDate is the exclusive upper bound (the day after the user's inclusive picker selection).
// rangeDays = wire delta = number of inclusive calendar days selected.
// 366 allows a full calendar year including leap years.
export const MAX_BACKFILL_RANGE_DAYS = 366;

export const triggerSupportV2EmailBackfill = unaryRpc({
  name: "triggerSupportV2EmailBackfill" as const,
  input: z
    .object({
      teamIds: z.array(MongoTeamId.schema).min(1),
      channel: BackfillEmailChannelSchema,
      startDate: z.date(),
      endDate: z.date(),
    })
    .refine(({ startDate, endDate }) => endDate > startDate, {
      message: "End date must be after start date.",
    })
    .refine(
      ({ startDate, endDate }) =>
        (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) <=
        MAX_BACKFILL_RANGE_DAYS,
      { message: `Date range cannot exceed ${MAX_BACKFILL_RANGE_DAYS} days.` },
    ),
  output: z.object({ results: z.array(TriggerSupportV2EmailBackfillResult) }),
});

export type TriggerSupportV2EmailBackfillInput = z.infer<
  typeof triggerSupportV2EmailBackfill.input
>;

export type TriggerSupportV2EmailBackfillOutput = z.infer<
  typeof triggerSupportV2EmailBackfill.output
>;
